import Icon from 'veui/components/Icon'
import { IconColorPalette } from 'dls-icons-vue'

Icon.register('color-palette', IconColorPalette)
